module.exports = __webpack_public_path__ + "img/shop5_1_m.c8080963.png";